angular.module('SupportAgent')
.controller('UserSearchController',function($scope,$rootScope,$location, $mdDialog, L,INTERACT) {
 $scope.on_search_item = function(acid) { // TODO: make it a link instead
  var account = INTERACT.get_account(acid);
  if(!account) account = INTERACT.add_account(acid);
  account.load_conversations(function(e,r) {
   if(e) return L.error({err:e},"failed to load conversations for the found user");
   var og = r.find(function(x){return x.is_alive()});
   if(og) return $location.path('/support/'+acid+'/'+og.id);
   $mdDialog.show(
    $mdDialog.confirm()
    .title($rootScope.strings.str_no_open_conversation)
    .textContent($rootScope.strings.str_want_2_create_ticket)
    .ok($rootScope.strings.str_continue)
    .cancel($rootScope.strings.str_close)
   ).then(function(/*outcome*/) {
    L.trace("yes, let's create a conversation");
    $scope.busy_screen=true;
    account.create_conversation({},function(e,r) {
     $scope.busy_screen=false;
     if(e) {
      if(e.reason=="timeout") {
       $mdDialog.show(
        $mdDialog.alert()
         .title($rootScope.strings.str_connection_timeout)
         .textContent($rootScope.strings.str_plz_login)
         .ok($rootScope.strings.ok_btn)
       ).then(function() {
        $rootScope.showLoginPage();
       });
      }
      return L.error({err:e},"failed to create conversation");
     }
     $location.path('/support/'+acid+'/'+r.convid);
    });
   },function() {
    L.trace("no, we are not creating a conversation");
   });
  });
 };
});
